const C = {
  name: "ApiExplorer",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.02 2C6.80772 2 5.02 3.78772 5.02 6V9C5.02 10.1077 4.12772 11 3.02 11H2V13H3C4.10772 13 5 13.8923 5 15V18C5 20.2123 6.78771 22 9 22H10.03V20H9C7.89228 20 7 19.1077 7 18V15C7 13.809 6.48186 12.741 5.65827 12.0088C6.49346 11.2762 7.02 10.2006 7.02 9V6C7.02 4.89228 7.91228 4 9.02 4H10.02V2H9.02Z" fill="currentColor"/>
<path d="M21.02 13C19.9123 13 19.02 13.8923 19.02 15V18C19.02 20.2123 17.2323 22 15.02 22H14.02V20H15.02C16.1277 20 17.02 19.1077 17.02 18V15C17.02 13.797 17.5487 12.7195 18.3868 11.9868C17.5661 11.2547 17.05 10.1886 17.05 9V6C17.05 4.89228 16.1577 4 15.05 4H14.02V2H15.05C17.2623 2 19.05 3.78772 19.05 6V9C19.05 10.1077 19.9423 11 21.05 11H22.05V13H21.02Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as ApiExplorer
};
